<template>
    <canvas
        ref="canvas"
        @mousewheel="onMouseWheel"
        @mousedown="onMouseDown"
        @mousemove="onMouseMove"
        @mouseup="onMouseUp">
    </canvas>
</template>

<script>
export default {
    props: {
        img: null
    },
    data: function() {
        return {
            canvas: null,
            ctx: null,
            image: null,
            lastX: null,
            lastY: null,
            scaleFactor: 1.1,
            dragStart: null,
            dragged: null
        };
    },
    methods: {
        redraw() {
            var p1 = this.ctx.transformedPoint(0, 0);
            var p2 = this.ctx.transformedPoint(
                this.canvas.width,
                this.canvas.height
            );
            this.ctx.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);

            this.ctx.save();
            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.ctx.restore();

            this.ctx.drawImage(this.image, 0, 0);
        },
        trackTransforms(ctx) {
            var svg = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'svg'
            );
            var xform = svg.createSVGMatrix();
            ctx.getTransform = function() {
                return xform;
            };

            var savedTransforms = [];
            var save = ctx.save;
            ctx.save = function() {
                savedTransforms.push(xform.translate(0, 0));
                return save.call(ctx);
            };

            var restore = ctx.restore;
            ctx.restore = function() {
                xform = savedTransforms.pop();
                return restore.call(ctx);
            };

            var scale = ctx.scale;
            ctx.scale = function(sx, sy) {
                xform = xform.scaleNonUniform(sx, sy);
                return scale.call(ctx, sx, sy);
            };

            var rotate = ctx.rotate;
            ctx.rotate = function(radians) {
                xform = xform.rotate((radians * 180) / Math.PI);
                return rotate.call(ctx, radians);
            };

            var translate = ctx.translate;
            ctx.translate = function(dx, dy) {
                xform = xform.translate(dx, dy);
                return translate.call(ctx, dx, dy);
            };

            var transform = ctx.transform;
            ctx.transform = function(a, b, c, d, e, f) {
                var m2 = svg.createSVGMatrix();
                m2.a = a;
                m2.b = b;
                m2.c = c;
                m2.d = d;
                m2.e = e;
                m2.f = f;
                xform = xform.multiply(m2);
                return transform.call(ctx, a, b, c, d, e, f);
            };

            var setTransform = ctx.setTransform;
            ctx.setTransform = function(a, b, c, d, e, f) {
                xform.a = a;
                xform.b = b;
                xform.c = c;
                xform.d = d;
                xform.e = e;
                xform.f = f;
                return setTransform.call(ctx, a, b, c, d, e, f);
            };

            var pt = svg.createSVGPoint();
            ctx.transformedPoint = function(x, y) {
                pt.x = x;
                pt.y = y;
                return pt.matrixTransform(xform.inverse());
            };
        },
        onMouseWheel(evt) {
            var delta = evt.wheelDelta
                ? evt.wheelDelta / 40
                : evt.detail
                    ? -evt.detail
                    : 0;
            if (delta) this.zoom(delta);
            return evt.preventDefault() && false;
        },
        onMouseDown(evt) {
            //   document.body.style.mozUserSelect = document.body.style.webkitUserSelect = document.body.style.userSelect = 'none';
            this.lastX = evt.offsetX || evt.pageX - this.canvas.offsetLeft;
            this.lastY = evt.offsetY || evt.pageY - this.canvas.offsetTop;
            this.dragStart = this.ctx.transformedPoint(this.lastX, this.lastY);
            this.dragged = false;
        },
        onMouseMove(evt) {
            this.lastX = evt.offsetX || evt.pageX - this.canvas.offsetLeft;
            this.lastY = evt.offsetY || evt.pageY - this.canvas.offsetTop;
            this.dragged = true;
            if (this.dragStart) {
                var pt = this.ctx.transformedPoint(this.lastX, this.lastY);
                this.ctx.translate(
                    pt.x - this.dragStart.x,
                    pt.y - this.dragStart.y
                );
                this.redraw();
            }
        },
        onMouseUp(evt) {
            this.dragStart = null;
            if (!this.dragged) this.zoom(evt.shiftKey ? -1 : 1);
        },
        rotate(evt) {
            this.ctx.translate(this.image.width / 2, this.image.height / 2);
            this.ctx.rotate(Math.PI / 2);
            this.ctx.translate(-this.image.width / 2, -this.image.height / 2);
            this.redraw();
            return evt.preventDefault() && false;
        },
        zoom(clicks) {
            var pt = this.ctx.transformedPoint(this.lastX, this.lastY);
            this.ctx.translate(pt.x, pt.y);
            var factor = Math.pow(this.scaleFactor, clicks);
            this.ctx.scale(factor, factor);
            this.ctx.translate(-pt.x, -pt.y);
            this.redraw();
        },
        toDataURL() {
            return this.canvas.toDataURL();
        },
        fitImage() {
            var widthRatio = this.canvas.width / this.image.width;
            var heightRatio = this.canvas.height / this.image.height;
            var factor = 1;
            var tx = 0;
            var ty = 0;
            if (widthRatio > heightRatio) {
                factor = heightRatio;
                tx = (this.image.height - this.image.width) / 2;
            } else {
                factor = widthRatio;
                ty = (this.image.width - this.image.height) / 2;
            }
            this.ctx.scale(factor, factor);
            this.ctx.translate(tx, ty);
        }
    },
    mounted() {
        this.canvas = this.$refs.canvas;
        this.canvas.width = 400;
        this.canvas.height = 400;
        this.lastX = this.canvas.width / 2;
        this.lastY = this.canvas.height / 2;
        this.ctx = this.canvas.getContext('2d');
        this.trackTransforms(this.ctx);
        this.image = new Image();
        this.image.src = this.img;
        this.fitImage();
        this.redraw();
    }
};
</script>
